<template>
  <v-progress-circular
    :color="color"
    indeterminate
    :size="size"
    :width="width"
  ></v-progress-circular>
</template>

<script lang="ts" setup>
const props = defineProps({
  color: {
    type: String,
    default: "blue-500",
  },
  size: {
    type: Number,
    default: 20,
  },
  width: {
    type: Number,
    default: 2,
  },
});
</script>

<style lang="scss" scoped></style>
